import ScheduleCard from './ScheduleCard';

export default ScheduleCard;
